var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.enabled ? _c('span', {
    staticClass: "p-0.5 border-2 rounded-full relative cursor-pointer",
    class: [_vm.error !== undefined && 'border-red-700', _vm.error === undefined && 'border-indigo-600'],
    on: {
      "click": _vm.startRecognition
    }
  }, [!_vm.recording ? _c('Icon', {
    staticClass: "h-5 w-5 text-indigo-600",
    attrs: {
      "name": "microphone"
    }
  }) : _c('Icon', {
    staticClass: "h-5 w-5 text-red-700",
    attrs: {
      "name": "microphone"
    }
  }), _vm._v(" "), _vm.error !== undefined ? _c('span', {
    staticClass: "absolute min-w-64 z-20 mt-2 shadow-red-light p-4 bg-red-300 text-red-700 border border-1 rounded-md border-red-700"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }